import {
  changePassword,
  resetPassword,
  validateResetPassword,
  login,
  passwordPolicy,
  logout
} from '../api/account'

import { setAuthToken, setLoggedUser, clear} from '../storage.js'


export async function PasswordChange(params) {
  const  result = await changePassword(params);
  return result;
}

export async function PasswordReset(params) {
  const result = await resetPassword(params);
  return result;
}

export async function PasswordValidateReset(params) {
  const result = await validateResetPassword({ token: params });
  if (result?.data) {
    setLoggedUser(result.data);
    setAuthToken(result.headers["x-auth-token"]);
    return true;
  }
  return false;
}

export async function Login(account, pass) {
  const result = await login({login: account, password: pass})
  if (result?.data) {
    setLoggedUser(result.data);
    setAuthToken(result.headers["x-auth-token"]);
    return true;
  } 
  return false;
}

export async function Logout() {
  const result = await logout();
  clear();
}

export async function getPolicyCriteria() {
  const policy = await passwordPolicy();
  
  if (policy) {
    if (policy.criteria.special.all) {
      policy.criteria.special.include = ["-", "+", "!", "*", "$", "@", "%", "_", ".", ",", "?"]; 
    }
    return policy.criteria;
  }
}